<span class="dds-h5">{{ headerTitle }}</span>
<button type="button" class="dds-modal__close dds-icon dds-icon_close" (click)="close()"></button>
